import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Oval } from 'react-loader-spinner';
import { useSelector } from 'react-redux';

import { getIsLoading } from 'store/user-service/selector';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

import * as Styled from './styled';

interface DeleteAccountModalProps {
	open: boolean;
	handleClose: () => void;
	handleConfirm: () => void;
}

export const DeleteAccountModal: FC<DeleteAccountModalProps> = ({
	open,
	handleClose,
	handleConfirm,
}) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const isLoading = useSelector(getIsLoading);

	return (
		<InfoModal
			isOpen={open}
			image={<Error />}
			onClose={handleClose}
			title={modalTranslate('deleteAccountModal.title')}
			description={modalTranslate('deleteAccountModal.description')}
			buttons={
				<>
					{isLoading ? (
						<Styled.ConfirmButton variant="outlined" color="error" disabled={isLoading}>
							<Oval
								height={24}
								width={24}
								color="#fff"
								wrapperStyle={{}}
								wrapperClass=""
								visible={true}
								ariaLabel="oval-loading"
								secondaryColor="#91B6FF"
								strokeWidth={5}
								strokeWidthSecondary={5}
							/>
						</Styled.ConfirmButton>
					) : (
						<Styled.ConfirmButton variant="outlined" color="error" onClick={handleConfirm}>
							{modalTranslate('deleteAccountModal.confirm')}
						</Styled.ConfirmButton>
					)}

					<Styled.CancelButton variant="contained" color="error" onClick={handleClose}>
						{modalTranslate('deleteAccountModal.cancel')}
					</Styled.CancelButton>
				</>
			}
		></InfoModal>
	);
};
